"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

/**
 * ScrollToTop — scrolls the window to the top whenever the route changes.
 *
 * Drop this component once inside a layout or wrapper that is shared across
 * all pages (e.g. MainPage). It listens to Next.js pathname changes and
 * scrolls to the top automatically.
 */
export default function ScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
